import { useEffect, useState } from "react";
import { View } from "react-native";

import Button from "$src/core/components/atoms/Button/Button";
import Icon from "$src/core/components/atoms/Icon";
import Text from "$src/core/components/atoms/Text/Text";
import TVFocusGuideView from "$src/core/components/atoms/TVFocusGuideView";
import type { IconName } from "$src/core/models/icon";
import Logging from "$src/core/services/logging/logging";

import $ from "./ErrorPage.styles";

type Props = {
  title: string;
  subtitle?: string;
  ctaText?: string;
  ctaIcon?: IconName;
  error?: unknown;
  onPressCta?: (() => Promise<void>) | (() => void);
};

const ErrorPage: React.FC<Props> = ({
  title,
  subtitle,
  ctaText,
  ctaIcon,
  error,
  onPressCta,
}) => {
  const [isCtaPending, setIsCtaPending] = useState(false);

  const handlePressCta = async () => {
    if (onPressCta) {
      try {
        setIsCtaPending(true);
        await onPressCta();
      } finally {
        setIsCtaPending(false);
      }
    }
  };

  useEffect(() => {
    if (error) {
      Logging.error(error);
    }
  }, [error]);

  return (
    <View style={$.container}>
      <Icon name="circle-info" style={$.icon} />

      <Text preset="heading3" accessibilityRole="header" style={$.title}>
        {title}
      </Text>

      {subtitle && (
        <Text preset="body" accessibilityRole="text" style={$.subtitle}>
          {subtitle}
        </Text>
      )}

      {onPressCta && ctaText && (
        <TVFocusGuideView style={$.cta} autoFocus>
          <Button
            name="error_cta"
            preset="primary"
            onPress={handlePressCta}
            label={ctaText}
            icon={ctaIcon}
            isLoading={isCtaPending}
          />
        </TVFocusGuideView>
      )}
    </View>
  );
};

export default ErrorPage;
